jQuery(function ($) {
  // faq
  //$(".faqTitle:first").addClass('open').next(".faqDetails").slideDown();
  $(".faqTitle").click(function () {
    $(".faqDetails").slideUp();
    $(".faqTitle").removeClass("open");
    if ($(this).next(".faqDetails").is(":hidden")) {
      $(this).next(".faqDetails").slideDown();
      $(this).addClass("open");
    }
  });

  $('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})
});

   
